// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import ReactPlayer from "react-player/lazy"
import VideoIcon from '../../../assets/icons/videoPlayIcon.svg';
import cn from 'classnames';
import Button from '../../../components/Button';
import { useAsync } from 'react-use';
import { useEvent } from '../../../hooks/useEvent';
import { useAuthentication } from '../../../contexts/AuthContext';

const EventContent = () => {
  const currentVideoContent = JSON.parse(window.localStorage.getItem('selectedVideo'));
  const [selectedVideo, setSelectedVideo] = useState<CourseItem | null>(null);
  const itemRefs = useRef({});
  const navigate = useNavigate();

  const { selectedEvent } = useAuthentication();
  const { getEventByIdWithChallenges } = useEvent();
  const { value: eventDescription = [] } = useAsync(() =>
    getEventByIdWithChallenges(selectedEvent?._id), [selectedEvent]);

  const courseContent = eventDescription?.courseContent;
  const eventContentData = useMemo(() => {
    if (courseContent) {
      return courseContent;
    }
    return null;
  }, [courseContent]);
  
  useEffect(() => {
    if (currentVideoContent) {
      setSelectedVideo(currentVideoContent);
    } else if (eventContentData?.content?.length > 0) {
      setSelectedVideo(eventContentData?.content[0]?.items[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedVideo?.url && itemRefs.current[selectedVideo.url]) {
      itemRefs.current[selectedVideo.url].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedVideo]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleVideoSelect = (item) => {
    console.log("Selected video:", item);
    setSelectedVideo(item);
  };

  return (
    <div className="flex flex-row h-[70vh] w-full">
      {/* Sidebar */}
      <div className="w-80 border-r-2">
        <Button
          type="button"
          variant="primary-outline"
          customClass="h-10"
          onClick={handleBack}
        >
          <div className="text-indigo-600 text-base font-bold font-['Manrope']">
            Go Back
          </div>
        </Button>

        <div className="overflow-scroll max-h-[65vh] py-2 pr-2 mt-2">
          {eventContentData?.content?.map((section, sectionIndex) => (
            <div key={`${section?.title}-${sectionIndex}`} className="py-1">
              {/* Section Title */}
              <div className="mb-1 px-1">
                <h2 className="text-lg text-indigo-700 tracking-tight border-l-4 border-indigo-500 pl-3">
                  {section?.title}
                </h2>
              </div>
            
              {/* Video Items List */}
              <div className="flex flex-col gap-2">
                {section?.items.map((item, itemIndex) => {
                  const key = `${sectionIndex}-${itemIndex}`;
                  const isSelected = selectedVideo?.url === item.url;
            
                  return (
                    <div
                      key={key}
                      ref={(el) => { itemRefs.current[item.url] = el; }}
                      role="button"
                      onClick={() => handleVideoSelect(item)}
                      className={cn(
                        "flex items-center gap-2 px-2 py-3 rounded-md shadow-sm transition duration-150 cursor-pointer",
                        "bg-white hover:bg-gray-50 text-gray-700",
                        isSelected && "bg-indigo-50 border border-indigo-200 ring-1 ring-indigo-300"
                      )}
                    >
                      <img src={VideoIcon} alt="Video Icon" className="w-5 h-5 text-indigo-500" />
                      <span className="font-medium text-sm">{item?.title}</span>
                    </div>
                  );
                })}
              </div>
            </div>          
          ))}
        </div>
      </div>

      {/* Video Player */}
      <div className="w-full h-full p-2">
        <div className="relative w-full h-full" id="video-container">    
          <ReactPlayer
            url={selectedVideo?.url}
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  rel: 0,               // no related videos
                  modestbranding: 1,    // no big YouTube logo
                  cc_load_policy: 1,    // captions on
                  controls: 1,          // show controls
                  disablekb: 0,         // enable keyboard
                  fs: 1,                // allow fullscreen
                  playsinline: 1,       // inline playback
                  origin: window.location.origin, // avoid YouTube info leak
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventContent;
